( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      $( document ).on( 'click', '.llwc-products-filter .searchandfilter h4', function() {
        $( this ).parent( 'li' ).toggleClass( 'is-closed' );
      } );

      $( '#llwc-clear-products-filters' ).on( 'click', function() {
        $( '.searchandfilter input' ).each( function( index, element ) {
          $( element ).prop( 'checked', false );
        } );
        $( '.searchandfilter' ).submit(); // submit the form, this will trigger ajax if its setup
      } );

      if ( window.matchMedia( '(max-width: 768px)' ).matches && $( '.llwc-products-filter .searchandfilter h4' ).length ) {
        $( '.llwc-products-filter .searchandfilter h4' ).parent( 'li' ).toggleClass( 'is-closed' );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'woocommerce-filter', COMPONENT );
} )( app );
